@import 'src/styles/fonts';

.pdfLabel {
  @include barlow(16);

  .link {
    pointer-events: auto;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}

.inputLabel {
  margin-top: 1em !important;
}

.radioGroup {
  margin: 1.5em 0 -1em 0;
}
